import { makeStyles } from '@material-ui/core';
import { ThemeInstance } from 'configs/theme';

export const useStyles = makeStyles((theme: ThemeInstance) => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingBottom: 5,
    borderBottom: '1px solid rgba(112, 112, 112, .23)',
  },
  button: {
    minWidth: 'auto',
    padding: 2,
    borderRadius: '50%',
  },
  icon: {
    fontSize: '2rem',
    color: theme.custom.darkBlue,
  },
  monthName: {
    marginLeft: 20,
    marginRight: 20,
    fontSize: 18,
    color: theme.custom.darkBlue,
    textTransform: 'capitalize',
  },
}));
